import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL-Konfiguration für Microsoft Azure AD Login.
 *
 * Tenant ID und Client ID kommen aus .env.local:
 *   NEXT_PUBLIC_AZURE_CLIENT_ID
 *   NEXT_PUBLIC_AZURE_TENANT_ID
 *
 * Redirect URI: http://localhost:3000 (Dev) – muss in Azure Portal
 * unter App Registration → Authentication → SPA eingetragen sein.
 */

const clientId = process.env.NEXT_PUBLIC_AZURE_CLIENT_ID?.trim() || '';
const tenantId = process.env.NEXT_PUBLIC_AZURE_TENANT_ID?.trim() || '';

// Microsoft SSO ist optional. Ohne diese Werte bleibt klassischer Login aktiv.
export const istMicrosoftLoginKonfiguriert = Boolean(clientId && tenantId);

// Fallbacks verhindern harte Runtime-Crashes bei fehlerhafter/missender Konfiguration.
const sichereClientId = clientId || '00000000-0000-0000-0000-000000000000';
const sichererTenant = tenantId || 'common';

export const msalConfig: Configuration = {
  auth: {
    clientId: sichereClientId,
    authority: `https://login.microsoftonline.com/${sichererTenant}`,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000',
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error('[MSAL]', message);
        }
      },
    },
  },
};

/**
 * Scopes für den Login – nur User.Read (Profil lesen).
 * Kein Zugriff auf E-Mails oder andere Daten.
 */
export const loginScopes = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};
